import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { NativeCallState } from './types'

const initialState: NativeCallState = {
  callerName: '',
  uuid: '',
  accepted: false,
  declined: false,
}

const { actions, reducer } = createSlice({
  name: 'nativecall',
  initialState,
  reducers: {
    incomingCall: (state, action: PayloadAction<string>) => {
      state.callerName = action.payload
    },
    displayNativeCall: (state, action: PayloadAction<{ callerName: string; uuid: string }>) => {
      state.callerName = action.payload.callerName
      state.uuid = action.payload.uuid
    },
    displayLocalNotifications: (state, action: PayloadAction<string>) => {
      state.callerName = action.payload
    },
    nativeCallAccepted: (state) => {
      state.accepted = true
    },
    nativeCallDeclined: (state) => {
      state.declined = true
    },
    endNativeCall: () => initialState,
    endUnresponsiveCall: () => initialState,
  },
})

export { actions as nativeCallActions, initialState }

export default reducer
